import type { MarketListing, MarketSubjectSnapshot } from "../domain/types.ts";
import { normalizeLocationText } from "../location/locationSearch.ts";
import type { MarketCandidate } from "./marketDataProvider.ts";
import { canonicalRoomLabel } from "./roomNormalization.ts";
import { effectiveApartmentArea } from "../domain/propertyMatching.ts";

export const marketListingToCandidate = (
  listing: MarketListing,
  subject: MarketSubjectSnapshot,
  providerId: string,
  sourceSnapshot: Record<string, unknown> = {}
): MarketCandidate => {
  const effectiveArea = effectiveApartmentArea({ area: listing.area, areas: listing.areas });
  return ({
  providerId,
  providerPropertyId: listing.id,
  transactionType: subject.transactionType,
  city: listing.city ?? subject.city,
  cityNormalized: normalizeLocationText(listing.city ?? subject.city),
  citySource: "custom",
  municipalityId: listing.municipalityId ?? listing.location?.municipalityId,
  locality: listing.locality ?? "",
  street: listing.street ?? "",
  streetNormalized: normalizeLocationText(listing.street ?? ""),
  streetSource: listing.street ? "custom" : undefined,
  propertyType: listing.propertyType ?? subject.propertyType,
  rooms: canonicalRoomLabel(listing.rooms),
  area: effectiveArea.value,
  condition: listing.condition ?? "",
  reconstruction: listing.reconstruction ?? "",
  electricity: listing.electricity ?? "",
  coreType: listing.coreType ?? "",
  kitchen: listing.kitchen ?? "",
  balconyType: listing.balconyType ?? "",
  cellar: listing.cellar ?? "",
  floor: listing.floor,
  totalFloors: listing.totalFloors,
  elevator: listing.elevator ?? "",
  orientation: listing.orientation ?? "",
  buildingCondition: listing.technical?.buildingCondition ?? "",
  buildingType: listing.buildingType,
  location: listing.location,
  areas: listing.areas,
  technical: listing.technical,
  equipment: listing.equipment,
  canonicalPropertyType: listing.canonicalPropertyType,
  fieldProvenance: listing.fieldProvenance,
  askingPrice: listing.askingPrice,
  listingStatus: listing.status,
  sourceName: listing.sourceName,
  sourceUrl: listing.sourceUrl ?? "",
  capturedAt: listing.capturedAt,
  sourceSnapshot: {
    providerPropertyId: listing.id,
    externalId: listing.externalId,
    title: listing.title,
    description: listing.description,
    agency: listing.agency,
    totalFloors: listing.totalFloors,
    buildingType: listing.buildingType,
    pricePerM2: listing.pricePerM2,
    areaBasis: effectiveArea.basis,
    canonicalRooms: listing.rooms,
    sources: listing.sources,
    sourceUrls: listing.sourceUrls,
    externalIds: listing.externalIds,
    dedupeReason: listing.dedupeReason,
    dedupeConfidence: listing.dedupeConfidence,
    dedupeConflicts: listing.dedupeConflicts,
    ...sourceSnapshot
  }
  });
};
